import queryString from 'query-string';
import { DECODING_ONLINE, WR } from '../../constants/measure';
import * as apiActions from '../api/apiActions';

class DecServiceClient {
    static NAME = DECODING_ONLINE.ASSESSMENT;

    static URL_RESULTS = '/lantern-decoding-api/results/v1/results';

    static URL_CONTENT = '/lantern-decoding-api/content/v1/forms';

    static MEASURES = [WR.MEASURE];

    /**
    * Constructs request url to Lantern Dec Content service based on the passed configs.
    * @param {str} period - BOY | MOY | EOY
    * @param {str} grade - student's grade
    * @param {str} measure - measure name
    */
    static constructFormEndpoint(period, grade, measure) {

        return `${DecServiceClient.URL_CONTENT}?period=${period}&grade=${grade}&measure=${measure}`;
    }

    /**
    * Constructs request url to Lantern Dec Content service with form id param.
    * @param {str} formId - measure names
    */
    static constructFormByIdEndpoint(formId) {
        return `${DecServiceClient.URL_CONTENT}/${formId}`;
    }

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({ studentId, grade, period, schoolYear } = {}) {
        const queryStr = queryString.stringify({
            student_uids: studentId,
            grade_level: grade,
            period,
            school_year: schoolYear,
        });
        return queryStr ? `${DecServiceClient.URL_RESULTS}?${queryStr}` : DecServiceClient.URL_RESULTS;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructResultEndpoint(resultId) {
        return `${DecServiceClient.URL_RESULTS}/${resultId}`;
    }

    /**
     * Sends GET request to endpoint with provided parameters
     * @param {str} period - BOY | MOY | EOY
     * @param {str} grade - student's grade
     * @param {str} measure - measure names
     * @param {str} formId - (optional) id of form
     * @param retryActionName - retry type of API call
     * @returns {JSON} server response
     */
    static getForm = (period, grade, measure, formId, retryActionName) => (dispatch) => {
        if (formId) {
            return dispatch(apiActions.makeRetriableGetRequest(DecServiceClient.constructFormByIdEndpoint(formId), retryActionName));
        }
        const endpoint = DecServiceClient.constructFormEndpoint(period, grade, measure);
        return dispatch(apiActions.makeRetriableGetRequest(endpoint, retryActionName));
    };
}

export default DecServiceClient;
